export default {"src":"/evde-internet/_next/static/media/calendar.8cf346b0.svg","height":48,"width":48};